import React from "react";
import { Text, useMantineTheme } from "@mantine/core";

interface EyebrowProps {
  children: React.ReactNode;
  accent?: string;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Eyebrow - Small uppercase label displayed above a heading.
 * Encodes the "kicker/eyebrow" role instead of passing size + textTransform inline.
 * Pass `accent` to color the label with a pillar or brand accent.
 * Usage: <Eyebrow>Section Label</Eyebrow>
 * Usage: <Eyebrow accent={pillar.textColor}>Reflect</Eyebrow>
 */
export const Eyebrow: React.FC<EyebrowProps> = ({
  children,
  accent,
  className,
  style,
}) => {
  const theme = useMantineTheme();
  const other = theme.other as Record<string, string>;

  return (
    <Text
      component="span"
      className={className}
      style={{
        color: accent ?? other.textDimmed,
        fontSize: "0.875rem",
        fontWeight: 600,
        letterSpacing: "0.15em",
        textTransform: "uppercase",
        lineHeight: 1.4,
        display: "inline-block",
        ...style,
      }}
    >
      {children}
    </Text>
  );
};

export default Eyebrow;
